import React, { FC } from 'react'
import Star from '../../../public/static/icons/star.svg'
import css from './Rate.module.scss'
import cx from 'classnames'

const Rate: FC<{ rate: number; big?: boolean; className?: string }> = ({
  rate,
  big,
  className,
}) => {
  const rates = () => {
    const ratesComp = []
    for (let i = 0; i < 5; i++) {
      if (i < rate) {
        ratesComp.push(<Star viewBox="0 0 12 11" key={i} />)
      } else {
        ratesComp.push(
          <Star viewBox="0 0 12 11" className={css.empty} key={i} />,
        )
      }
    }
    return ratesComp
  }

  return (
    <div className={cx(css.wrapper, big && css.big, className)}>{rates()}</div>
  )
}

export default Rate
